/* global Swiper */
Wee.fn.make('about', {
	init: function() {
		var $brands = $('ref:brandsItem'),
			$wrap = $('ref:upBrands'),
			brandSwiper = null;

		$.screen.map([
			{
				max: 1,
				callback: function() {
					$('ref:brandsList').addClass('swiper-wrapper');
					$brands.addClass('swiper-slide');
					brandSwiper = new Swiper('.about__brands-inner', {
						loop: true
					});
				}
			},
			{
				min: 2,
				callback: function() {
					$('ref:brandsList').removeClass('swiper-wrapper');
					$brands.removeClass('swiper-slide');

					if (brandSwiper) {
						brandSwiper.destroy(true, true);
					}
				}
			}
		]);

		$.events.on({
			'ref:brandsItem': {
				click: function(e, el) {
					var $item = $(el);

					clearTimeout(this.loadTimeout);
					$wrap.disable();
					this.loadTimeout = setTimeout(function() {
						$wrap.activate();
						$item.activate();
						$wrap.enable();
					}, 500);
				}
			},
			'ref:brandsBack': {
				click: function() {
					clearTimeout(this.loadTimeout);
					$wrap.disable();
					this.loadTimeout = setTimeout(function() {
						$wrap.deactivate();
						$brands.deactivate();
						$wrap.enable();
					}, 500);
				}
			}
		}, {
			namespace: 'about'
		});
	},
	unload: function() {
		$.events.off(null, '.about');

		if (this.brandSwiper) {
			this.brandSwiper.destroy(true, true);
		}
	}
});
